import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Coins } from "lucide-react";
import api from "@/lib/api";
import { fmtInt } from "@/lib/billing";

/* Pre-run credit estimate line. Call `onAllowed(bool)` so the caller can
 * disable its Start button when the balance is too low. */
export default function CreditEstimate({ action, params, onAllowed, className = "" }) {
  const [est, setEst] = useState(null);
  const key = JSON.stringify(params || {});
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.post("/billing/estimate", { action, params: params || {} });
        if (!alive) return;
        setEst(data);
        onAllowed?.(!!data.allowed);
      } catch { if (alive) { setEst(null); onAllowed?.(true); } }
    })();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action, key]);

  if (!est || est.credits <= 0) return null;
  const low = !est.allowed;
  return (
    <div
      className={"inline-flex flex-wrap items-center gap-x-2 gap-y-1 rounded-md border px-2.5 py-1.5 text-xs " +
        (low ? "border-amber-300 bg-amber-50 text-amber-900" : "border-slate-200 bg-slate-50 text-slate-700") + " " + className}
      data-testid={`credit-estimate-${action}`}
    >
      <Coins className="h-3.5 w-3.5 shrink-0" />
      <span>≈ <strong className="tabular-nums">{fmtInt(est.credits)}</strong> {est.pool_label?.toLowerCase() || est.pool}</span>
      {!est.exempt
        ? <span className="text-slate-500">· you have <strong className="tabular-nums">{fmtInt(est.balance)}</strong></span>
        : <span className="text-slate-400">{est.exempt_reason === "admin" ? "· admin (metered, not blocked)" : "· billing not live — free for now"}</span>}
      <span className="text-slate-400 hidden sm:inline">· {est.basis}</span>
      {low ? <Link to="/billing" className="font-semibold underline" data-testid={`credit-estimate-topup-${action}`}>Top up</Link> : null}
    </div>
  );
}
